import { trackPageView, initScrollAnimations } from '../lib';

export function initPrivacyPolicyPage(): void {
  console.log('Initializing privacy policy page');
  initScrollAnimations();
  trackPageView();
}

if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', initPrivacyPolicyPage);
}
